import { QueryResult, useQuery } from '@apollo/client'

import { GET_PASSENGER_PROPERTIES_AUTOCOMPLETE } from 'features/PassengerProperties/queries-legacy'
import { GTPassengerPropertiesAutocompleteInput, GTPassengerPropertiesAutocompleteOutput } from 'gql/types.generated'

interface IQueryData {
  passengerPropertiesAutocomplete: GTPassengerPropertiesAutocompleteOutput[]
}

interface IUsePassengerPropertiesAutocompleteInput {
  queryInput: GTPassengerPropertiesAutocompleteInput
}

export const usePassengerPropertiesAutocomplete = ({
  queryInput
}: IUsePassengerPropertiesAutocompleteInput): QueryResult<IQueryData> => {
  return useQuery(GET_PASSENGER_PROPERTIES_AUTOCOMPLETE, {
    variables: {
      input: queryInput
    }
  })
}
